import { render, staticRenderFns } from "./humanInjury.vue?vue&type=template&id=4c8f16b0&scoped=true"
import script from "./humanInjury.vue?vue&type=script&lang=js"
export * from "./humanInjury.vue?vue&type=script&lang=js"
import style0 from "./humanInjury.vue?vue&type=style&index=0&id=4c8f16b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8f16b0",
  null
  
)

export default component.exports